function jsonify(params: any) {
  return JSON.stringify(params);
}

export default jsonify;
